import { render, staticRenderFns } from "./AuthorizedTenantUsers.vue?vue&type=template&id=6ab82814"
import script from "./AuthorizedTenantUsers.vue?vue&type=script&lang=js"
export * from "./AuthorizedTenantUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports